// =========================================================
// frontend/js/permissions.js - V10.0 (CSRD & Snapshot-Security)
// =========================================================

// 1. Das Rechte-Register (Zentraler Katalog)
window.PERMISSIONS = {
    VIEW_DASHBOARD: 'view_dashboard',
    VIEW_TEAM_STATS: 'view_team_stats',
    CALENDAR_VIEW_TEAM: 'calendar_view_team',
    CALENDAR_EDIT_OWN: 'calendar_edit_own',
    CALENDAR_EDIT_GLOBAL: 'calendar_edit_global', 
    HR_VIEW_ABSENCES: 'hr_view_absences', 
    HR_EDIT_ABSENCES: 'hr_edit_absences', 
    MANAGE_USERS: 'manage_users', 
    MANAGE_ROLES: 'manage_roles', 
    MANAGE_BILLING: 'manage_billing',
    EDIT_SETTINGS: 'edit_settings',
    MANAGE_LIMITS: 'manage_limits', 
    MANAGE_TREE: 'manage_tree',
    VIEW_APPROVALS: 'view_approvals',
    MANAGE_APPROVALS: 'manage_approvals', 
    MANAGE_GLOBAL_EVENTS: 'manage_global_events',
    VACATION_APPROVE: 'vacation_approve', 
    
    // NEU: CSRD & Nachhaltigkeits-Management
    MANAGE_IMPACT: 'manage_impact', // Darf Snapshots synchronisieren & Berichte finalisieren
    
    SCOPE_VIEW: 'scope_view',             
    SCOPE_EDIT: 'scope_edit',             
    SCOPE_MANDATORY: 'scope_mandatory'    
};

// 2. Die Standard-Rollen-Vorlagen (Default Policies)
window.DEFAULT_ROLES = {
    'WERKSTUDENT': [
        window.PERMISSIONS.VIEW_DASHBOARD
    ],
    'EMPLOYEE': [
        window.PERMISSIONS.VIEW_DASHBOARD,
        window.PERMISSIONS.CALENDAR_VIEW_TEAM,
        window.PERMISSIONS.CALENDAR_EDIT_OWN,
        window.PERMISSIONS.VIEW_APPROVALS
    ],
    'MANAGER': [
        window.PERMISSIONS.VIEW_DASHBOARD,
        window.PERMISSIONS.CALENDAR_VIEW_TEAM,
        window.PERMISSIONS.CALENDAR_EDIT_OWN,
        window.PERMISSIONS.VIEW_TEAM_STATS,
        window.PERMISSIONS.VIEW_APPROVALS,
        window.PERMISSIONS.MANAGE_APPROVALS,
        window.PERMISSIONS.VACATION_APPROVE
    ],
    'HR': [
        window.PERMISSIONS.VIEW_DASHBOARD,
        window.PERMISSIONS.CALENDAR_VIEW_TEAM,
        window.PERMISSIONS.CALENDAR_EDIT_OWN,
        window.PERMISSIONS.VIEW_TEAM_STATS,
        window.PERMISSIONS.HR_VIEW_ABSENCES,
        window.PERMISSIONS.HR_EDIT_ABSENCES,
        window.PERMISSIONS.MANAGE_USERS,
        window.PERMISSIONS.MANAGE_LIMITS,
        window.PERMISSIONS.MANAGE_TREE,
        window.PERMISSIONS.MANAGE_ROLES,
        window.PERMISSIONS.VIEW_APPROVALS,
        window.PERMISSIONS.MANAGE_APPROVALS,
        window.PERMISSIONS.VACATION_APPROVE,
        window.PERMISSIONS.MANAGE_IMPACT // HR darf standardmäßig Impact-Daten prüfen
    ],
    'ADMIN': [
        window.PERMISSIONS.VIEW_DASHBOARD,
        window.PERMISSIONS.MANAGE_USERS,
        window.PERMISSIONS.MANAGE_ROLES,
        window.PERMISSIONS.MANAGE_TREE,
        window.PERMISSIONS.MANAGE_IMPACT // Admin darf Snapshot-Sync ausführen
    ],
    'OWNER': Object.values(window.PERMISSIONS)
};

// Aktive Rollen (Initialer State)
window.activeRoles = JSON.parse(JSON.stringify(window.DEFAULT_ROLES));

/**
 * 3. Die globale Rechte-Prüfung
 * Prüft Rolle + individuelle Sonderrechte
 */
window.hasPermission = function(action) {
    const user = window.currentUser;
    if (!user) return false;
    
    // Der OWNER ist "God-Mode"
    if (user.role === 'OWNER') return true;

    const userRole = user.role || 'EMPLOYEE';
    const rolePermissions = window.activeRoles[userRole] || [];
    const hasRolePermission = rolePermissions.includes(action);

    // Sonderrechte (extraPermissions) aus dem Mitarbeiter-Modal
    const extraPermissions = user.extraPermissions || [];
    const hasExtraPermission = extraPermissions.includes(action);

    return hasRolePermission || hasExtraPermission;
};

/**
 * 4. Die Scope-Rechte-Prüfung (Zuständigkeits-Matrix)
 */
window.hasScopePermission = function(targetScopeId, action) {
    const user = window.currentUser;
    if (!user) return false;
    if (user.role === 'OWNER') return true;
    
    // Sonderregel: Wer global Urlaub genehmigen darf, darf es in jedem Scope
    if (action === window.PERMISSIONS.VACATION_APPROVE && window.hasPermission(window.PERMISSIONS.VACATION_APPROVE)) {
        return true;
    }

    // Prüfung der gemanagten Abteilungen (Matrix)
    if (user.managedScopes && user.managedScopes[targetScopeId]) {
        if (user.managedScopes[targetScopeId].includes(action)) {
            return true;
        }
    }
    return false;
};

// =========================================================
// HILFSFUNKTIONEN FÜR DIE UI-STEUERUNG
// =========================================================

window.canManageLimits = function() {
    return window.hasPermission(window.PERMISSIONS.MANAGE_LIMITS) || 
           window.hasPermission(window.PERMISSIONS.MANAGE_USERS);
};

window.canApproveVacation = function(targetScopeId) {
    return window.hasScopePermission(targetScopeId, window.PERMISSIONS.SCOPE_EDIT) || 
           window.hasPermission(window.PERMISSIONS.VACATION_APPROVE);
};

window.canApproveRequests = function(targetScopeId) {
    return window.hasScopePermission(targetScopeId, window.PERMISSIONS.SCOPE_EDIT) || 
           window.hasPermission(window.PERMISSIONS.MANAGE_APPROVALS);
};

window.canViewAdminPanel = function() {
    return window.hasPermission(window.PERMISSIONS.MANAGE_USERS) || 
           window.hasPermission(window.PERMISSIONS.MANAGE_ROLES) ||
           window.hasPermission(window.PERMISSIONS.MANAGE_TREE) ||
           window.hasPermission(window.PERMISSIONS.MANAGE_IMPACT);
};

// CSRD Spezial-Check
window.canSyncImpact = function() {
    return window.hasPermission(window.PERMISSIONS.MANAGE_IMPACT);
};

// Prüft ob der User einen bestimmten dynamischen Status buchen darf
window.canBookStatus = function(statusId) {
    // Falls keine explizite Regel existiert, darf jeder die Standard-Status buchen
    if (['HO', 'vacation', 'sick'].includes(statusId)) return true;
    return window.hasPermission(`status_${statusId}`);
};